module.exports = __webpack_public_path__ + "static/media/bnr_hero_logo_color.884b58ce.png";